export default __webpack_public_path__ + "static/media/click-to-pay.59cfc615.svg";